"use client";

import { useRef, useEffect, useState } from "react";

export function VideoBackgroundSection() {
  const videoARef = useRef<HTMLVideoElement | null>(null);
  const videoBRef = useRef<HTMLVideoElement | null>(null);
  const [activeLayer, setActiveLayer] = useState<0 | 1>(0);
  const videos = ["/presenter-with-clowd.mp4", "/presentor.mp4", "/judges.mp4"];

  useEffect(() => {
    let currentIndex = 0;
    const cycleDuration = 10000; // how long each video plays in ms

    const playOnLayer = async (layer: 0 | 1, src: string) => {
      const el = layer === 0 ? videoARef.current : videoBRef.current;
      if (!el) return;
      // set source and play
      el.src = src;
      el.loop = true;
      el.muted = true;
      el.playsInline = true;
      try {
        await el.play();
      } catch (e) {
        // autoplay may be blocked on some browsers; muted should help but ignore errors
      }
      // activate the layer so CSS crossfade will show it
      setActiveLayer(layer);
    };

    // start first video on layer 0
    playOnLayer(0, videos[0]);

    const interval = setInterval(() => {
      const nextIndex = (currentIndex + 1) % videos.length;
      const nextLayer: 0 | 1 = activeLayer === 0 ? 1 : 0;
      // play next video on the inactive layer then switch
      playOnLayer(nextLayer, videos[nextIndex]);
      currentIndex = nextIndex;
    }, cycleDuration);

    return () => {
      clearInterval(interval);
    };
    // we intentionally don't include activeLayer in deps to avoid resetting interval
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="relative h-[500px] md:h-[600px] overflow-hidden">
      {/* Dual-layer Video Background for smooth crossfade */}
      <video
        ref={videoARef}
        className={`absolute inset-0 h-full w-full object-cover object-top transition-opacity duration-1000 ${
          activeLayer === 0 ? "opacity-100" : "opacity-0"
        }`}
        muted
        playsInline
        poster="/conference-networking.png"
      />

      <video
        ref={videoBRef}
        className={`absolute inset-0 h-full w-full object-cover object-top transition-opacity duration-1000 ${
          activeLayer === 1 ? "opacity-100" : "opacity-0"
        }`}
        muted
        playsInline
        poster="/conference-networking.png"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-primary/60" />

      {/* Content */}
      <div className="relative z-10 flex h-full items-center justify-center">
        <div className="container mx-auto px-4 text-center">
          <h2 className="mb-6 text-4xl font-bold text-white md:text-5xl lg:text-6xl text-balance">
            Experience the Summit
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-white/90 md:text-xl text-pretty">
            Africa isn’t just preparing for the future — we’re building it now.
          </p>
        </div>
      </div>
    </section>
  );
}
